'use strict';

angular.module('contartemx.cuenta.administrar.metodo_pago', [
	'contartemx',
	'ui.router',
	'ui.bootstrap'
])

.controller('MetodoDePagoCtrl', function MetodoDePagoController($scope, $state, callToWebService) {

    $scope.pagoRegistrado = false;
    $scope.estaRegresando = false;
    $scope.IDPagoPaypal =
    $scope.Costo =
    $scope.NumeroItem =
    $scope.RetornoFail =
    $scope.RetornoSuccess =
    $scope.UrlIPN =
    $scope.UrlPayPal =
    $scope.ValorCustom = null;
    $scope.TransReferencia = "";

    callToWebService.postCall('ObtenerPantallaMetodoDePago', {},
	    function success(data) {
	        if (data.Respuesta && !data.EsError) {
	            
	            $scope.pagoRegistrado = data.Respuesta.HayPagoRegistrado;
	            $scope.IDPagoPaypal = data.Respuesta.IDPagoPaypal;
	            $scope.Costo = data.Respuesta.Costo;
	            $scope.NumeroItem = data.Respuesta.NumeroItem;
	            $scope.RetornoFail = data.Respuesta.RetornoFail;
	            $scope.RetornoSuccess = data.Respuesta.RetornoSuccess;
	            $scope.UrlIPN = data.Respuesta.UrlIPN;
	            $scope.UrlPayPal = data.Respuesta.UrlPayPal;
	            $scope.ValorCustom = data.Respuesta.ValorCustom; 
	            $scope.TransReferencia = data.Respuesta.TransReferencia;
        $scope.TransBanco = data.Respuesta.TransBanco;
        $scope.TransClabe = data.Respuesta.TransClabe;
        $scope.TransCuenta = data.Respuesta.TransCuenta;
        $scope.TransNombre = data.Respuesta.TransNombre;
      } else {
	            $scope.mostrarNotificacion(true, data.Mensaje, true);
	        }
	    },
	    function error(data) {
	        $scope.mostrarNotificacion(true, data.Mensaje, true);
	    });

    $scope.saveID = function () {
        callToWebService.postCall('GuardarIdDePayPal', { paypalId: $scope.paypalId },
			function success(data) {
			    
			    $scope.estaRegresando = true;
			},
			function error(data) {
			    
			});
    };
});
